import { TXGridTemplate } from "../../../types/common/templates.types";

export const X_GRID_COL_3: TXGridTemplate = {
  "Grille à 3 Colonnes": {
    template: [
      {
        name: "XGrid",
        props: {
          all: {
            columns: 3,
          },
        },
      },
    ],
  },
};
